import axios from "axios";

const base = `${process.env.REACT_APP_BACKEND_URL}/change-orders`;
const token = () => localStorage.getItem("token");
const headers = () => ({ headers: { Authorization: "Bearer " + token() } });

export const getMeta = () => axios.get(`${base}/meta`, headers());
export const listChangeOrders = filters => axios.post(`${base}/list`, filters, headers());
export const getChangeOrder = id => axios.get(`${base}/${id}`, headers());
export const createChangeOrder = body => axios.post(base, body, headers());
export const updateChangeOrder = (id, body) => axios.put(`${base}/${id}`, body, headers());
export const deleteChangeOrder = id => axios.delete(`${base}/${id}`, headers());
export const announce = (id, body) => axios.post(`${base}/${id}/announce`, body, headers());
export const sendOffer = (id, body) => axios.post(`${base}/${id}/offer`, body, headers());
export const remind = (id, body) => axios.post(`${base}/${id}/remind`, body, headers());
export const revise = (id, body) => axios.post(`${base}/${id}/revise`, body, headers());
export const withdraw = (id, body) => axios.post(`${base}/${id}/withdraw`, body, headers());
export const decide = (id, body) => axios.post(`${base}/${id}/decide`, body, headers());
export const deletePhoto = (id, photoId) =>
  axios.delete(`${base}/${id}/photos/${photoId}`, headers());

export const uploadPhoto = (id, blob) => {
  const body = new FormData();
  body.append("photo", blob, blob.type === "image/png" ? "photo.png" : "photo.jpg");
  return axios.post(`${base}/${id}/photos`, body, headers());
};

export const pdfUrl = (id, variant = "offer") =>
  `${base}/${id}/pdf?variant=${variant}&token=${encodeURIComponent(token() || "")}`;
export const photoUrl = (id, photoId) =>
  `${base}/${id}/photos/${photoId}?token=${encodeURIComponent(token() || "")}`;

// The customer's approval page (no login; the tenant comes from ?domain=)
const publicBase = `${process.env.REACT_APP_BACKEND_URL}/public-change-orders`;
const domainQuery = domain => `?domain=${encodeURIComponent(domain || "")}`;
export const getPublicChangeOrder = (token, domain) =>
  axios.get(`${publicBase}/${token}${domainQuery(domain)}`);
export const decidePublic = (token, domain, body) =>
  axios.post(`${publicBase}/${token}/decide${domainQuery(domain)}`, body);
export const publicPdfUrl = (token, domain) => `${publicBase}/${token}/pdf${domainQuery(domain)}`;
export const publicPhotoUrl = (token, domain, photoId) =>
  `${publicBase}/${token}/photos/${photoId}${domainQuery(domain)}`;
